import { render, staticRenderFns } from "./GData.vue?vue&type=template&id=456feada&scoped=true"
import script from "./GData.vue?vue&type=script&lang=js"
export * from "./GData.vue?vue&type=script&lang=js"
import style0 from "./GData.vue?vue&type=style&index=0&id=456feada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456feada",
  null
  
)

export default component.exports